import classNames from "classnames";
import CalendarOffIcon from "../../../icons/CalendarOffIcon";
import CalendarEventGraphic from "../../../icons/graphics/CalendarEventGraphic";
import PawGraphic from "../../../icons/graphics/PawGraphic";
import LoginStatIcon from "../../../icons/LoginStatIcon";
import UserIcon from "../../../icons/UserIcon";
import UserPlusIcon from "../../../icons/UserPlusIcon";
import PillIcon from "../../../icons/PillIcon";

type PracticeStatCardProps = {
  type: string;
  statValue: string | number;
  subHeading: string;
};

const PracticeStatCard = ({
  type,
  statValue,
  subHeading,
}: PracticeStatCardProps): JSX.Element => {
  return (
    <div className="w-full h-full px-5 py-6 bg-white shadow-default">
      <div className="flex items-center gap-6">
        <div
          className={classNames(
            "w-16 h-16 rounded-full grid place-content-center flex-shrink-0 self-start",
            {
              "bg-lightest":
                type === "logins" ||
                type === "appts_booked" ||
                type === "match_registrations" ||
                type === "prescription_requests_submitted",
              "bg-success-lightest":
                type === "new_registrations" || type === "new_patients",
              "bg-error-lightest": type === "appts_cancelled",
            },
          )}
        >
          <span className="w-10 h-10">
            {type === "logins" && <LoginStatIcon className="text-primary" />}
            {type === "new_registrations" && (
              <UserPlusIcon className="text-success" />
            )}
            {type === "new_patients" && <PawGraphic className="text-success" />}
            {type === "appts_booked" && (
              <CalendarEventGraphic className="text-primary" />
            )}
            {type === "appts_cancelled" && (
              <CalendarOffIcon className="text-error" />
            )}
            {type === "match_registrations" && (
              <UserIcon className="text-primary" />
            )}
            {type === "prescription_requests_submitted" && (
              <PillIcon className="text-primary" />
            )}
          </span>
        </div>

        <div className="flex flex-col justify-between gap-[2px]">
          <h3 className="text-2xl tablet:text-[2rem] tablet:leading-8 font-bold">
            {statValue}
          </h3>
          <p className="tablet:text-sm desktop:text-base">{subHeading}</p>
        </div>
      </div>
    </div>
  );
};

export default PracticeStatCard;
